import actionRules from './actionRules';
import { IStateMachineProps } from './sm.types';
import StateMachine from '../../../services/stateMachine';
import { IEX_STATE_CODES } from '../../../constants/configs/states';
import { IEnrolledMemberCTAButton } from '../types/customGroupingTypes';
import { EnrolledGroupCTAButtonTypes } from '../../../constants/individualPortal/customGrouping/customGrouping.constants';

function createStateMachine<T>({ ROOT_STATE, stateCode, smResult, onFinishCb }: IStateMachineProps<T>) {
    const smActionRules = actionRules(stateCode);

    const onFinish = res => {
        onFinishCb?.();
        smResult = res;
    };

    let stateMachineFurtherActions = new StateMachine(smActionRules, ROOT_STATE, onFinish);

    return (model, config?) => {
        stateMachineFurtherActions.run(model, config);
        return smResult;
    };
}

export const enrolledGroupCTASM = (stateCode: IEX_STATE_CODES, onFinishCb?: Function) => {
    let smResult: IEnrolledMemberCTAButton = {
        btnText: '',
        type: EnrolledGroupCTAButtonTypes.IS_BLANK,
    };
    return createStateMachine({
        ROOT_STATE: 'enrolledMemberCta',
        stateCode,
        smResult,
        onFinishCb,
    });
};
